// ─────────────────────────────────────────────
//  PercentageSummary.jsx — Desglose del cálculo
// ─────────────────────────────────────────────

import React from 'react';
import styles from './PercentageSummary.module.css';
import { formatCurrency } from '../../utils/format';

function formatPctTag(value) {
	const num = parseFloat(value) || 0;
	if (Number.isInteger(num)) return `${num}%`;
	return `${parseFloat(num.toFixed(2))}%`;
}

export default function PercentageSummary({
	amount,
	pct,
	adjustment,
	finalAmount,
	hasAmount,
	mode,
}) {
	const isDiscount = mode === 'discount';
	const adjustmentLabel = isDiscount ? 'Descuento' : 'Aumento';
	const finalLabel = isDiscount ? 'Total final' : 'Total con aumento';

	return (
		<section className={styles.card} aria-label="Desglose del cálculo" aria-live="polite">
			<div className={styles.row}>
				<span className={styles.rowLabel}>Monto original</span>
				<span className={styles.rowValue}>
					{hasAmount ? formatCurrency(amount) : '—'}
				</span>
			</div>

			<div className={styles.row}>
				<span className={styles.rowLabel}>
					{adjustmentLabel}{' '}
					<span className={styles.pctTag}>({formatPctTag(pct)})</span>
				</span>
				<span className={`${styles.rowValue} ${styles.rowValue2} ${isDiscount ? styles.discountColor : styles.addColor}`}><strong>
					{hasAmount ? (
						<>
							{isDiscount ? '−' : '+'}
							{formatCurrency(adjustment)}
						</>
					) : '—'}
				
				</strong></span>
			</div>

			<div className={styles.divider} />

			<div className={`${styles.row} ${styles.totalRow}`}>
				<span className={styles.totalLabel}>{finalLabel}</span>
				<span className={`${styles.totalValue} ${styles.totalColor}`}>
					{hasAmount ? formatCurrency(finalAmount) : '—'}
				</span>
			</div>
		</section>
	);
}
